/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

export const getLastUpdatedList = (
  limitAmount: number,
  chain: string,
  orderBy: string,
  searchField = '',
) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      if (chain != 'all') {
        collectionRef = collectionRef.where('chain', '==', chain)
      }

      collectionRef = collectionRef.where('active', '==', true)

      if (searchField != '') {
        collectionRef = collectionRef
          .where('lowercase_name', '>=', searchField)
          .where('lowercase_name', '<=', searchField + '~')
          .orderBy('lowercase_name', 'desc')
      }

      if (orderBy == 'last_updated_at') {
        collectionRef = collectionRef.orderBy('last_updated_at', 'asc')
      } else {
        collectionRef = collectionRef.orderBy('stats.market_cap', 'desc')
      }

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          queryRef.docs.map((doc: any) => {
            // console.log('DOC', doc.data())
            // if (doc.data().floor_price == 0) {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)
            // }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLastUpdatedList | error', error)
      reject(error)
    }
  })
}

{
  /** Get latest project news */
}
export const getLatestProjectNews = (
  limitAmount: number,
  // chain: string,
  orderBy = 'posted_at',
  origin: string,
  // origin = '',
  // topProject: boolean,
) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.PROJECT_ANNOUNCEMENTS)

      if (origin != 'all') {
        collectionRef = collectionRef.where('origin', '==', origin)
      }

      // collectionRef = collectionRef.where('origin', '==', origin)

      collectionRef = collectionRef.orderBy('posted_at', 'desc')
      /* if (orderBy == 'posted_at') {
        collectionRef = collectionRef.orderBy('posted_at', 'desc')
      } else {
        collectionRef = collectionRef.orderBy('stats.market_cap', 'desc')
      } */

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          queryRef.docs.map((doc: any) => {
            // console.log('DOC', doc.data())
            // if (doc.data().floor_price == 0) {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)
            // }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLatestProjectNews | error', error)
      reject(error)
    }
  })
}

/**
 * This method will request collection listings
 * data from firestore order by price
 */
export const getSolListingsLastUpdated = (
  limit: number,
  orderBy: string,
  searchField = '',
): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let topCollectionRef: any = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      topCollectionRef = topCollectionRef.where('chain', '==', 'solana')

      if (searchField != '') {
        topCollectionRef = topCollectionRef
          .where('lowercase_name', '>=', searchField)
          .where('lowercase_name', '<=', searchField + '~')
          .orderBy('lowercase_name', 'desc')
      }

      topCollectionRef
        .orderBy('stats.market_cap', 'desc')
        .limit(orderBy == 'last_updated_at' ? 250 + limit : limit)
        .get()
        .then((queryRef: any) => {
          let i = 0
          queryRef.docs.map(async (doc: any) => {
            const getListingsData = await getLastUpdatedListings(doc.data().slug)

            const point = {
              ...doc.data(),
              id: doc.id,
              listings: getListingsData,
            }
            temp.push(point)

            if (i == queryRef.docs.length - 1) {
              if (orderBy == 'last_updated_at') {
                const tempFiltered = temp.filter((obj: any) => obj?.listings != null)
                tempFiltered.sort(
                  (a: any, b: any) => a?.listings?.lastUpdatedTime - b?.listings?.lastUpdatedTime,
                )
                resolve(tempFiltered)
              } else {
                resolve(temp)
              }
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSolanaCollectionsListings | error', error)
      reject(error)
    }
  })
}

/**
 * This method will request collection listings
 * data from firestore order by price
 */
export const getLastUpdatedListings = (slug: string): Promise<any> => {
  return new Promise((resolve) => {
    const listingRef: any = getCollectionReference(collectionNames.COLLECTION_LISTINGS)

    listingRef
      // .where('top_collection_id', '==', id)
      .where('slug', '==', slug)
      .orderBy('modified_at', 'asc')
      .get()
      .then((query: any) => {
        if (!query.empty) {
          const totalItems = query.size
          const snapshot = query.docs[query.size - 1]
          const lastUpdatedItem = snapshot.data()
          const lastUpdatedTime = lastUpdatedItem?.modified_at?.seconds

          resolve({
            totalItems,
            lastUpdatedTime,
          })
        } else {
          resolve(null)
        }
      })
      .catch((error: any) => {
        console.log('Error getting collection listing', error)
      })
  })
}
